import { User, UserPasswords } from "@linkfluence/models/user";
import { CreateUser, SearchUser } from "@radarly/models/user";

interface Picture {
  id: number;
  url: string;
}

export interface UserRepo {
  updateCurrentUser(id: number, user: Partial<User>): Promise<User>;
  fetchCurrentUser(): Promise<User>;
  getCurrentUser(): User;
  getUserPictures(user: number): Promise<Picture[]>;
  deleteUserPicture(id: number, picture: number): Promise<void>;
  uploadUserPictures(id: number, files: File[]): Promise<Picture[]>;
  updateUserPassword(
    id: number,
    passwords: UserPasswords
  ): Promise<{ incorrectPassword: boolean }>;
  resetUserPassword(email: string): Promise<{ ok: boolean }>;
  createUser(user: CreateUser): Promise<Omit<SearchUser, "workspaces">>;
}

export const UserRepositoryUID = Symbol("Linkfluence/UserRepo");
